// removed by extract-text-webpack-plugin
module.exports = {"optionContainer":"purify_Default__optionContainer___1GCFW"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/shared/Default/Default.scss
// module id = 223
// module chunks = 0